import axios from 'axios';

export default {
  // Generic collaborators selector.
  selectors: (params = {}, config = {}) => axios.get('collaborators/selectors', { params, ...config }),
  // Options for "Vendedor" selector.
  sellers: (params = {}, config = {}) => axios.get('collaborators/sellers', { params, ...config }),
  // Options for "Responsable" selector.
  managers: (params = {}, config = {}) => axios.get('collaborators/managers', { params, ...config }),
  // Collaborators with invoice_mailing flag for invoice send copy selector.
  invoiceMailingSelectors: (params = {}, config = {}) => axios.get('collaborators/invoice-mailing/selectors', { params, ...config }),
};
